/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { abnormalPaymentControllerFindAll } from '../fn/abnormal-payment/abnormal-payment-controller-find-all';
import { AbnormalPaymentControllerFindAll$Params } from '../fn/abnormal-payment/abnormal-payment-controller-find-all';
import { abnormalPaymentControllerGetCount } from '../fn/abnormal-payment/abnormal-payment-controller-get-count';
import { AbnormalPaymentControllerGetCount$Params } from '../fn/abnormal-payment/abnormal-payment-controller-get-count';
import { abnormalPaymentControllerGetFailedItems } from '../fn/abnormal-payment/abnormal-payment-controller-get-failed-items';
import { AbnormalPaymentControllerGetFailedItems$Params } from '../fn/abnormal-payment/abnormal-payment-controller-get-failed-items';
import { abnormalPaymentControllerGetGroupItems } from '../fn/abnormal-payment/abnormal-payment-controller-get-group-items';
import { AbnormalPaymentControllerGetGroupItems$Params } from '../fn/abnormal-payment/abnormal-payment-controller-get-group-items';
import { abnormalPaymentControllerGetItems } from '../fn/abnormal-payment/abnormal-payment-controller-get-items';
import { AbnormalPaymentControllerGetItems$Params } from '../fn/abnormal-payment/abnormal-payment-controller-get-items';
import { abnormalPaymentControllerGetUsage } from '../fn/abnormal-payment/abnormal-payment-controller-get-usage';
import { AbnormalPaymentControllerGetUsage$Params } from '../fn/abnormal-payment/abnormal-payment-controller-get-usage';
import { AbnormalPaymentCountDto } from '../models/abnormal-payment-count-dto';
import { AbnormalPaymentDto } from '../models/abnormal-payment-dto';
import { AbnormalPaymentGroupResponseDto } from '../models/abnormal-payment-group-response-dto';
import { AbnormalPaymentResponseDto } from '../models/abnormal-payment-response-dto';
import { AbnormalPaymentUsageDto } from '../models/abnormal-payment-usage-dto';

@Injectable({ providedIn: 'root' })
export class AbnormalPaymentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `abnormalPaymentControllerFindAll()` */
  static readonly AbnormalPaymentControllerFindAllPath = '/api/abnormal-payment';

  /**
   * 엑셀로 받은 이상 결제 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `abnormalPaymentControllerFindAll()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  abnormalPaymentControllerFindAll$Response(params: AbnormalPaymentControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AbnormalPaymentDto>>> {
    return abnormalPaymentControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 엑셀로 받은 이상 결제 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `abnormalPaymentControllerFindAll$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  abnormalPaymentControllerFindAll(params: AbnormalPaymentControllerFindAll$Params, context?: HttpContext): Observable<Array<AbnormalPaymentDto>> {
    return this.abnormalPaymentControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AbnormalPaymentDto>>): Array<AbnormalPaymentDto> => r.body)
    );
  }

  /** Path part for operation `abnormalPaymentControllerGetFailedItems()` */
  static readonly AbnormalPaymentControllerGetFailedItemsPath = '/api/abnormal-payment/failed';

  /**
   * 엑셀로 받은 이상 결제 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `abnormalPaymentControllerGetFailedItems()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  abnormalPaymentControllerGetFailedItems$Response(params: AbnormalPaymentControllerGetFailedItems$Params, context?: HttpContext): Observable<StrictHttpResponse<AbnormalPaymentResponseDto>> {
    return abnormalPaymentControllerGetFailedItems(this.http, this.rootUrl, params, context);
  }

  /**
   * 엑셀로 받은 이상 결제 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `abnormalPaymentControllerGetFailedItems$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  abnormalPaymentControllerGetFailedItems(params: AbnormalPaymentControllerGetFailedItems$Params, context?: HttpContext): Observable<AbnormalPaymentResponseDto> {
    return this.abnormalPaymentControllerGetFailedItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<AbnormalPaymentResponseDto>): AbnormalPaymentResponseDto => r.body)
    );
  }

  /** Path part for operation `abnormalPaymentControllerGetUsage()` */
  static readonly AbnormalPaymentControllerGetUsagePath = '/api/abnormal-payment/usage';

  /**
   * 엑셀로 받은 이상 결제 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `abnormalPaymentControllerGetUsage()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  abnormalPaymentControllerGetUsage$Response(params: AbnormalPaymentControllerGetUsage$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AbnormalPaymentUsageDto>>> {
    return abnormalPaymentControllerGetUsage(this.http, this.rootUrl, params, context);
  }

  /**
   * 엑셀로 받은 이상 결제 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `abnormalPaymentControllerGetUsage$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  abnormalPaymentControllerGetUsage(params: AbnormalPaymentControllerGetUsage$Params, context?: HttpContext): Observable<Array<AbnormalPaymentUsageDto>> {
    return this.abnormalPaymentControllerGetUsage$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AbnormalPaymentUsageDto>>): Array<AbnormalPaymentUsageDto> => r.body)
    );
  }

  /** Path part for operation `abnormalPaymentControllerGetCount()` */
  static readonly AbnormalPaymentControllerGetCountPath = '/api/abnormal-payment/count';

  /**
   * 엑셀로 받은 이상 결제 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `abnormalPaymentControllerGetCount()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  abnormalPaymentControllerGetCount$Response(params: AbnormalPaymentControllerGetCount$Params, context?: HttpContext): Observable<StrictHttpResponse<AbnormalPaymentCountDto>> {
    return abnormalPaymentControllerGetCount(this.http, this.rootUrl, params, context);
  }

  /**
   * 엑셀로 받은 이상 결제 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `abnormalPaymentControllerGetCount$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  abnormalPaymentControllerGetCount(params: AbnormalPaymentControllerGetCount$Params, context?: HttpContext): Observable<AbnormalPaymentCountDto> {
    return this.abnormalPaymentControllerGetCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<AbnormalPaymentCountDto>): AbnormalPaymentCountDto => r.body)
    );
  }

  /** Path part for operation `abnormalPaymentControllerGetGroupItems()` */
  static readonly AbnormalPaymentControllerGetGroupItemsPath = '/api/abnormal-payment/group';

  /**
   * 엑셀로 받은 이상 결제 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `abnormalPaymentControllerGetGroupItems()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  abnormalPaymentControllerGetGroupItems$Response(params: AbnormalPaymentControllerGetGroupItems$Params, context?: HttpContext): Observable<StrictHttpResponse<AbnormalPaymentGroupResponseDto>> {
    return abnormalPaymentControllerGetGroupItems(this.http, this.rootUrl, params, context);
  }

  /**
   * 엑셀로 받은 이상 결제 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `abnormalPaymentControllerGetGroupItems$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  abnormalPaymentControllerGetGroupItems(params: AbnormalPaymentControllerGetGroupItems$Params, context?: HttpContext): Observable<AbnormalPaymentGroupResponseDto> {
    return this.abnormalPaymentControllerGetGroupItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<AbnormalPaymentGroupResponseDto>): AbnormalPaymentGroupResponseDto => r.body)
    );
  }

  /** Path part for operation `abnormalPaymentControllerGetItems()` */
  static readonly AbnormalPaymentControllerGetItemsPath = '/api/abnormal-payment/list';

  /**
   * 엑셀로 받은 이상 결제 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `abnormalPaymentControllerGetItems()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  abnormalPaymentControllerGetItems$Response(params: AbnormalPaymentControllerGetItems$Params, context?: HttpContext): Observable<StrictHttpResponse<AbnormalPaymentResponseDto>> {
    return abnormalPaymentControllerGetItems(this.http, this.rootUrl, params, context);
  }

  /**
   * 엑셀로 받은 이상 결제 데이터를 업로드합니다.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `abnormalPaymentControllerGetItems$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  abnormalPaymentControllerGetItems(params: AbnormalPaymentControllerGetItems$Params, context?: HttpContext): Observable<AbnormalPaymentResponseDto> {
    return this.abnormalPaymentControllerGetItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<AbnormalPaymentResponseDto>): AbnormalPaymentResponseDto => r.body)
    );
  }

}
